export default "__VITE_ASSET__M4z_0kmt__"